import { z } from "zod";

/**
 * Someone asking to be let in: only the address. `/welcome` asks for the name.
 * The same address submitted again is stored once; the response never says which.
 */
export const accessRequestInput = z.object({
  email: z.string().trim().pipe(z.email("Bitte geben Sie eine gültige E-Mail-Adresse ein")),
});
export type AccessRequestInput = z.infer<typeof accessRequestInput>;

/** A welcome link's token plus the password chosen on `/welcome`. */
export const acceptAccessInput = z.object({
  token: z.string().trim().min(1),
  password: z.string().min(8, "Mindestens 8 Zeichen").max(128, "Höchstens 128 Zeichen"),
  name: z.string().trim().max(200, "Höchstens 200 Zeichen").optional(),
});
export type AcceptAccessInput = z.infer<typeof acceptAccessInput>;

export const previewAccessInput = z.object({
  token: z.string().trim().min(1),
});
export type PreviewAccessInput = z.infer<typeof previewAccessInput>;
